// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"d6d7226f","453":"43c830d1","551":"9cb254bc","570":"a97ed7db","911":"691b9f2d"}[chunkId] + ".chunk.js";
};